import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { toastr } from 'react-redux-toastr';
import moment from 'moment';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import { tableAdjustableColExportOptions, renderCustomHeader } from '../../helpers/table';
import SearchBar from '../../SearchBar';

import CompanyAddContainer from './CompanyAddContainer';
import ModalManageJobKey from '../modals/ModalManageJobKey';
import GreyHeader from '../../../component/dump/menuComponents/GreyHeader';
import CustomButton from '../../CustomButton';
import { redirectToRoscoLive } from '../../helpers/helperRedirect';

import '../../dump/menuComponents/menuComponents.sass';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import { getPartnerCompanies, getPartnerData } from "../../../action/CompaniesActions";
import { getDevices } from "../../../action/DeviceActions";

const CompanyContainer = (props) => {
	const navigate = useNavigate();
	const { user, company, toggleLoader } = props
	const userRole = user.roles[0]
	const userPartnerName = user.partner_company_name || user.company_name

	const [state, setState] = useState({
		data: {},
		searchText: '',
		initialData: [],
		companies: [],
		modal: {
			show: false,
			content: '',
			error: false,
		},
		delete_company: {},
		open: false,

		showModalDeviceAuditLog: false,
		activeCompany: null,
		devices: [],

		partnerCompany: {},
	})
	const readCompanyOnly = !state.partnerCompany.allow_edit_company || userRole !== 'partner'
	const hasAccessAddCompany = state.partnerCompany.allow_create_company && userRole === 'partner'

	const [showManageJobKey, setShowManageJobKey] = useState(false);
	const [selectCompany, setSelectCompany] = useState({});
	// console.log('PROPS CompanyContainer: ', props)
	// console.log('STATES CompanyContainer: ', state)
	useEffect(() => {
		getCompanisAndDevices();
	}, []);

	const toggleLiveActive = (cell, row) => {
		return cell ? "Yes" : "No"
	}

	const getCompanisAndDevices = async () => {
		toggleLoader(true);

		const requestArray = [];
		requestArray.push(getPartnerCompanies({ include_data: 'data_usage' }))
		requestArray.push(getDevices())
		requestArray.push(getPartnerData({ partner_name: userPartnerName }))
		await Promise.all(requestArray)
			.then(res => {
				const companyData = res[0].data.response.companies
				const partnerCompany = res[2].data.response.company
				const initDevices = res[1].data.response.devices.map((item) => {
					item.cameraError = (item.channel_status && item.channel_status.length && item.channel_status.find(channel => channel.fail_ts > (channel.success_ts || '1970-01-01 00:00:00') && item.channel_available.includes(channel.channel))) ? 1 : 0;
					item.recordingError = (!_.isEmpty(item.latest_hdderror) && item.latest_hdderror.count) > 0 ? 1 : 0;
					item.recordingError = (!_.isEmpty(item.latest_hdderror) && item.latest_hdderror.count) > 0 ? 1 : 0;
					item.checked = true;
					// FWSD-4314 - If device does not receive GPS from device and ignition is Off more 24 hours (1440 mins) then display Online status.
					// Device stopped receive GPS, broken antena or something, and FileServer does not know when ignition is On.
					// if ((row.ignition && row.ignition.state) || (!row.gps_online && durationInMins > 1440)) {
					let onlineStatus = 'parking'
					if (!item.online) {
						onlineStatus = 'offline'
					}
					else {
						// const ignitionOffTS = item.ignition && item.ignition.ts ? item.ignition.ts : ''; // 2023-01-04 18:50:37
						// const duration = moment.duration(moment.utc().diff(moment.utc(ignitionOffTS), 'seconds'), 'seconds')
						// const durationInMins = duration.asMinutes()

						if ((item.ignition && item.ignition.state) /*|| (!item.gps_online && durationInMins > 1440)*/) {
							onlineStatus = 'online'
						}
					}
					item.onlineStatus = onlineStatus

					return item;
				})
				// const last_firmware_packages = res[2] && res[2].data.response.last_firmware_packages

				companyData.map((company) => {
					let value = 0;
					initDevices.map(device => { if ((device.company_name === company.company_name) && !!device.activated_timestamp && !!device.active) value += 1 });
					company.active_vehicles = value
					company.available_data_pool = company.data_usage.available_data_pool
					company.total_data_usage = company.data_usage.total_data_usage

					return company;
				});

				setState({ ...state, companies: companyData, initialData: companyData, devices: initDevices, partnerCompany })
				// setLastFirmwarePackages(last_firmware_packages)
			})
			.catch(error => {
				toastr.error('There was an issue getting your available vehicles. Please try again later.')
			})
			.finally(() => {
				toggleLoader(false)
			})
	}

	const formatCompanyName = (cell, row) => {
		return (
			<CustomButton variant='link' style={{ whiteSpace: 'normal' }} onClick={() => redirectToRoscoLive('company', row.id)}>
				{cell}
			</CustomButton>
		)
	}

	const editCompany = (company) => {
		navigate('/company/edit', {
			state: { company, readOnly: readCompanyOnly },
		})
	}

	const dataSearch = (e) => {
		const value = e.target.value.toLowerCase();
		const filter = state.initialData.filter(item => (
			item.company_name.toLowerCase().includes(value)
		));

		setState({
			...state,
			companies: filter,
			searchText: value,
		});
	}

	const trialDateFormatter = (cell, row) => {
		if (row.trial_status && row.trial_date) {
			return (
				moment(row.trial_date).format('M/DD/YYYY')
			)
		}

		return '';
	};

	const earliestDateSort = (d) => (a, b, order, p) => {
		const a1 = a[p] ? moment(a[p]).valueOf() : 0
		const b1 = b[p] ? moment(b[p]).valueOf() : 0

		if (order === 'desc') {
			return b1 - a1
		}

		return a1 - b1;
	};

	const formatColumnDataLimit = (cell) => {
		let value = '';

		if (cell === 0) value = "Unlimited";
		if (cell === 2) value = "500 MB";
		if (cell === 3) value = "1 GB";

		return value
	}

	const formatCompanyKey = (cell, row) => {
		return (
			<CustomButton variant='link' disabled={userRole !== 'partner'} onClick={() => {
				setSelectCompany(row);
				setShowManageJobKey(true);
			}
			}>
				{cell}
			</CustomButton>
		)
	}

	const toggleActiveVehicles = (active_vehicles) => {
		return <span>{active_vehicles}</span>
	}

	const togglePreferredProfile = (profile_name, row) => {
		let company_id;
		state.companies.map(elm => { if (elm.company_name === row.company_name) company_id = elm.id });

		return <CustomButton variant="link" name={profile_name} onClick={(e) => redirectToRoscoLive('profile', company_id, profile_name)}>{profile_name}</CustomButton>
	}

	const formatTotalDataUsed = (cell, row) => {
		const res = (row.total_data_usage ? (row.total_data_usage / 1024 / 1024 / 1024) : 0).toFixed(2)

		if (+row.total_data_usage > +row.available_data_pool) {
			return <div className="error-label">{res}</div>
		}

		return res
	}

	const formatTotalDataUsedCSV = (cell, row) => (row.total_data_usage ? (row.total_data_usage / 1024 / 1024 / 1024) : 0).toFixed(2)

	const formatAvailableDataPool = (cell) => cell !== null ? (cell / 1024 / 1024 / 1024).toFixed(2) : 'Unlimited'

	const formatActions = (cell, row) => {
		return <CustomButton variant="link" onClick={() => editCompany(row)}>Edit Company</CustomButton>
	}

	return (
		<div>
			<GreyHeader
				title='Partner Portal'
				subtitle='Companies'
			/>
			<div className='page-subheader'>
				<div className='subheader-section search'>
					<SearchBar
						term={state.searchText}
						onSearch={dataSearch}
					/>
				</div>
			</div>

			<main className="manage-users main-content-block">
				{hasAccessAddCompany && // FWSD-5986
					<CompanyAddContainer getCompanies={getCompanisAndDevices} />
				}
				<div className="manage-users-table manage-companies-page-table">
					<BootstrapTable
						data={state.companies}
						{...tableAdjustableColExportOptions}
						csvFileName="companies_report.csv"
					>
						<TableHeaderColumn
							width="15%"
							dataField="company_name"
							dataSort
							dataFormat={formatCompanyName}
							isKey
							csvHeader="Company Name"
							// dataAlign='center'
							headerAlign='left'
							tdStyle={{ whiteSpace: 'normal', wordBreak: 'break-all' }}
						>
							{renderCustomHeader(0, 'Name')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="8%"
							dataField="trial_date"
							dataSort
							dataFormat={trialDateFormatter}
							sortFunc={earliestDateSort('trial_date')}
							csvHeader="Trial End Date"
							// dataAlign='center'
							headerAlign='left'
						>
							{renderCustomHeader(1, 'Trial End Date')}
						</TableHeaderColumn>
						{/* <TableHeaderColumn
							width="15%"
							dataField="data_limit"
							dataSort
							dataFormat={formatColumnDataLimit}
							csvHeader="Vehicle Data Limit"
							// dataAlign='center'
							headerAlign='left'
						>
							{renderCustomHeader(2, 'Vehicle Data Limit')}
						</TableHeaderColumn> */}
						<TableHeaderColumn
							width="8%"
							dataField="company_key"
							dataSort
							dataFormat={formatCompanyKey}
							csvHeader="Company Key"
							// dataAlign='center'
							headerAlign='left'
						>
							{renderCustomHeader(2, 'Company Key')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="8%"
							dataField="live_active"
							dataSort
							dataFormat={toggleLiveActive}
							csvHeader="Live Active?"
							// dataAlign='center'
							headerAlign='left'>
							{renderCustomHeader(3, 'Live Active?')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="8%"
							dataField="active_vehicles"
							dataSort
							dataFormat={toggleActiveVehicles}
							csvHeader="Active Vehicles"
							// dataAlign='center'
							headerAlign='left'
						>
							{renderCustomHeader(4, 'Active Vehicles')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="10%"
							dataField="profile_name"
							dataSort
							dataFormat={togglePreferredProfile}
							csvHeader="Preferred Profile"
							// dataAlign='center'
							headerAlign='left'
						>
							{renderCustomHeader(5, 'Preferred Profile')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="10%"
							dataField="total_data_usage"
							dataSort
							dataFormat={formatTotalDataUsed}
							csvFormat={formatTotalDataUsedCSV}
							csvHeader="Total Data Used"
							// dataAlign='center'
							headerAlign='left'
						>
							{renderCustomHeader(6, 'Total Data Used (GB)')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="10%"
							dataField="available_data_pool"
							dataSort
							dataFormat={formatAvailableDataPool}
							csvFormat={formatAvailableDataPool}
							csvHeader="Available Data Pool"
							// dataAlign='center'
							headerAlign='left'
						>
							{renderCustomHeader(7, 'Available Data Pool (GB)')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="6%"
							// dataField="available_data_pool"
							// dataSort
							dataFormat={formatActions}
							// csvHeader="Available Data Pool"
							// dataAlign='center'
							headerAlign='left'
						>
							Actions
						</TableHeaderColumn>
					</BootstrapTable>
				</div>
			</main >

			{showManageJobKey
				&& (
					<ModalManageJobKey
						onHide={() => setShowManageJobKey(false)}
						selectCompany={selectCompany}
					/>
				)}
		</div>
	)
}

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company,
		company_collection: state.partnerList.company_collection
	}),
	dispatch => ({
		editCompany: data => dispatch({ type: 'EDIT_COMPANY', payload: data }),
		editCompanyCollection: data => dispatch({ type: 'EDIT_COMPANY_COLLECTION', payload: data }),
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		},
	}),
)(CompanyContainer);
